export const ACTIVITY_GET = 'ACTIVITY_GET'



// WEBPACK FOOTER //
// ./src/store/actions/activity.js